import ImagesUrl from "#constants/images.js";
import React from "react";

const FileUploadMixSheet = ({
  fileInputRef,
  handleFileChange,
  triggerFileInput,
  fileName,
  handleFileRemove,
}) => {
  return (
    <div className="mix_upload_icon">
      <input
        type="file"
        className="d-none"
        accept=".pdf*"
        ref={fileInputRef}
        onChange={handleFileChange}
      />

      {/* Label that acts as a button for file upload */}
      <label>
        {fileName ? null : (
          <span className="attach_file_icon">
            <img
              src={ImagesUrl.attachWhiteIcon}
              alt="File"
              onClick={triggerFileInput}
            />
          </span>
        )}
        <span className="attch-text fw-medium fs-6 text-black">
          Attach Mix Sheet
        </span>

        {/* <span className="attch-text fw-medium fs-6 text-black">
          {fileName
            ? fileName.name
              ? fileName.name
              : fileName.split("/").pop()
            : "Attach Mix Sheet"}
        </span> */}
        {/* {fileName ? (
          <button className="remove_file">
            <img
              src={ImagesUrl.deleteIcon}
              alt="Trash"
              onClick={() => handleFileRemove(fileName)}
            />
          </button>
        ) : null} */}
      </label>
      <div className="file_img_preview_wrapper">
        {fileName ? (
          <div className="new_file_preview_item">
            <img src={ImagesUrl.pdfIcon} alt="Preview" />
            <button
              className="remove_file"
              onClick={() => handleFileRemove(fileName)}
            >
              <i className="fa fa-solid fa-xmark" />
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FileUploadMixSheet;
